export default __webpack_public_path__ + "static/media/delete_outline_24px_outlined.fcac4be3.svg";